import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

const PageTransition = ({ children, className = "" }: PageTransitionProps) => {
  return (
    <div
      className={`relative ${className}`}
      style={{ minHeight: "100dvh" }}
    >
      {children}
    </div>
  );
};

export default PageTransition;
